import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

// Gates the paid experience: a customer must be authenticated AND own a
// The Paycheck Edit entitlement. Authentication alone is never enough, and direct
// navigation without a purchase is bounced to sign in.
// When `requireOnboarded` is set, an entitled customer who has not finished
// onboarding is routed to /onboarding first.
// A deep link (e.g. from an operational email) preserves its intended
// destination via ?next= so login can return the customer to it.
export function RequireEntitlement({ children, requireOnboarded = false }) {
  const { entitled, onboardingComplete, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#FAF8F4]" data-testid="guard-loading">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-[#E5E0D9] border-t-[#2F6B57]" />
      </div>
    );
  }
  if (!entitled) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }
  if (requireOnboarded && !onboardingComplete) return <Navigate to="/onboarding" replace />;
  return children;
}
